import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
declare var MachnetWidget: any;


@Component({
  selector: 'app-upgrade-tier',
  templateUrl: './upgrade-tier.component.html',
  styleUrls: ['./upgrade-tier.component.scss']
})
export class UpgradeTierComponent implements OnInit {

  token
  sender_uuid 
  constructor(private auth: AuthService, private common:CommonService, private messageService : MessageService) { }

  ngOnInit(): void {
    this.sender_uuid = this.auth.user.uuid
    this.upgradeTier()
  }
  upgradeTier(){
    this.auth.getWidgetToken().subscribe((res:any)=>{
      this.token = res.token
      var widget = new MachnetWidget({
        elementId: "widget-root",
        senderId: this.sender_uuid,
        width: "100%",
        // height: "",
        fontSize:"14px",
        type: 'tier',
        locale: "en",
        multiStep: true,
        // stylesheet: "../../styles.scss",
        token: this.token,
      });
      widget.init();
      window.addEventListener("message", function (e) {
        // console.log("type", e.data.type)
        // console.log("all_detail", e.data) -> {type: "TIER", status: "TIER2_REQUESTED", message: "TIER 2 REQUESTED"}
        // console.log("all", e)
        if(e.data.status == "TIER2_REQUESTED"){
          //TIER3_REQUESTED
          //TIER_REQUEST_FAILED
          //tier_approved
          //send to api here

        }
      }.bind(this));
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
      errorKeys.forEach(key => { 
        let value = err.error.errors[key][0]; 
        this.messageService.add({severity:'error', summary:value, detail:""})
      }); 
    })
  }
}
